// Auto-généré par scripts/generate-version.js — NE PAS MODIFIER
const buildInfo = {
  version: '1.6.0',
  commitHash: '608af80',
  branch: 'master',
  context: 'production',
  buildDate: '2026-09-09',
};
export default buildInfo;
